import Immutable from 'immutable';
import { CLASS_POSITION } from './constants';

export const getEnrolledClasses = (profile) =>
  // filtering out LIBRARY classes here rather than API as some legacy stuff
  // depends on the getSchoolClass() below and we want that to be able to
  // access these library classes still.
  // path forward here is to remove use of getSchoolClass() and instead use
  // useClassDetail() which includes more information and is now accessible
  // to students.
  profile
    .get('school_classes')
    .filter(
      (schoolClass) =>
        schoolClass.get('position') === CLASS_POSITION.STUDENT &&
        schoolClass.get('school_class_type') !== 'LIBRARY'
    );

export const getTaughtClasses = (profile) =>
  profile
    .get('school_classes')
    .filter(
      (schoolClass) => schoolClass.get('position') === CLASS_POSITION.TEACHER
    );

export const getSupervisedClasses = (profile) =>
  profile
    .get('school_classes')
    .filter(
      (schoolClass) => schoolClass.get('position') === CLASS_POSITION.SUPERVISOR
    );

export const getOverseenClasses = (profile) => {
  // NOTE: This will not include classes which a poc is enrolled in at the school
  // they are poc for.
  return profile
    .get('school_classes')
    .filter(
      (schoolClass) =>
        schoolClass.get('position') === CLASS_POSITION.TEACHER ||
        schoolClass.get('position') === CLASS_POSITION.SUPERVISOR
    );
};

export const isOverseerOfClass = (profile, classId) => {
  return (
    profile.get('is_teacher') && getOverseenClasses(profile).has(`${classId}`)
  );
};

export const getSchoolClass = (profile, classId) =>
  profile.getIn(['school_classes', `${classId}`], Immutable.Map());

export const getKeystore = (profile) =>
  profile.get('keystore', Immutable.Map());

export const getKeystoreItem = (profile, key) => getKeystore(profile).get(key);

export const hasPermission = (profile, permission) =>
  profile.get('staff_permissions').has(permission);
